(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmLocationDialogController', AppraisalFirmLocationDialogController);

    AppraisalFirmLocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'AppraisalFirmLocation', 'AppraisalFirm', 'AppraisalFirmRegion', 'Principal'];

    function AppraisalFirmLocationDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                   AppraisalFirmLocation, AppraisalFirm, AppraisalFirmRegion, Principal) {
        var vm = this;

        vm.appraisalFirmLocation = entity;
        vm.isAdmin = Principal.hasAnyRole(['ADMIN']);
        vm.regionDisplayLine1 = 'Name: "' + vm.appraisalFirmLocation.appraisalFirmRegionName + '"';
        vm.regionDisplayLine2 = 'Appraisal Firm Region ID: ' + vm.appraisalFirmLocation.appraisalFirmRegionId;
        vm.clear = clear;
        vm.save = save;

        vm.appraisalfirms = AppraisalFirm.query({size: 2000});
        vm.allRegions = AppraisalFirmRegion.query({size: 2000});
        vm.firmRegions = [];

        vm.selectedFirm = null;
        vm.firmSearchText = '';
        vm.searchFirms = searchFirms;
        vm.onFirmSelected = onFirmSelected;

        vm.selectedRegion = null;
        vm.regionSearchText = '';
        vm.searchRegions = searchRegions;
        vm.onRegionSelected = onRegionSelected;

        if (!vm.isAdmin) {
            vm.allRegions.$promise.then(function(regions) {
                vm.firmRegions = regions;
            });
        }

        function searchFirms(searchText) {
            if (!searchText) {
                return vm.appraisalfirms;
            }
            var lowerSearch = searchText.toLowerCase();
            return vm.appraisalfirms.filter(function(firm) {
                return firm.name.toLowerCase().indexOf(lowerSearch) !== -1;
            });
        }

        function onFirmSelected(firm) {
            vm.appraisalFirmLocation.appraisalFirmId = firm ? firm.id : null;
            vm.selectedRegion = null;
            vm.regionSearchText = '';
            vm.appraisalFirmLocation.appraisalFirmRegionId = null;
            if (firm) {
                vm.allRegions.$promise.then(function(regions) {
                    vm.firmRegions = regions.filter(function(region) {
                        return region.appraisalFirmId === firm.id;
                    });
                });
            } else {
                vm.firmRegions = [];
            }
        }

        function searchRegions(searchText) {
            if (!searchText) {
                return vm.firmRegions;
            }
            var lowerSearch = searchText.toLowerCase();
            return vm.firmRegions.filter(function(region) {
                return region.name.toLowerCase().indexOf(lowerSearch) !== -1;
            });
        }

        function onRegionSelected(region) {
            vm.appraisalFirmLocation.appraisalFirmRegionId = region ? region.id : null;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appraisalFirmLocation.id !== null) {
                AppraisalFirmLocation.update(vm.appraisalFirmLocation, onSaveSuccess, onSaveError);
            } else {
                AppraisalFirmLocation.save(vm.appraisalFirmLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:appraisalFirmLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
